var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-by"},[_c('TopNavbar',{attrs:{"title":"基友秀"}}),_c('div',{staticClass:"moment-create-box"},[_c('MomentCreateComponent',{attrs:{"refItemId":_vm.refItemId,"config":_vm.config},on:{"postStatus":_vm.onPost}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }